import * as React from "react";
import { FormatCardNumber } from './shared';

const CardLogo = props => {
  if (props.type === 'mastercard') {
    return (
      <g>
        <path 
          fill="#ff5f00"
          d="M826.463 99.093h40.423v72.641h-40.423z"
        />
        <path
          d="M829.03 135.414a46.118 46.118 0 0117.644-36.321 46.198 46.198 0 100 72.641 46.118 46.118 0 01-17.644-36.32z"
          fill="#eb001b"
        />
        <path
          d="M921.42 135.414a46.196 46.196 0 01-74.746 36.32 46.205 46.205 0 000-72.641 46.196 46.196 0 0174.745 36.32zM917.012 164.04v-1.487h.6v-.303h-1.528v.303h.6v1.488zm2.965 0v-1.793h-.468l-.539 1.234-.538-1.234h-.469v1.794h.33v-1.353l.506 1.166h.342l.505-1.169v1.356z"
          fill="#f79e1b"
        />
      </g>
    );
  }
  else if (props.type === 'visa') {
    return (
      <g>
        <path
          d="m 195.57277,100.0008 c -21.26535,0 -40.26909,11.02226 -40.26909,31.38672 0,23.35418 33.70385,24.96725 33.70385,36.69975 0,4.94006 -5.66129,9.36219 -15.33056,9.36219 -13.72258,0 -23.97889,-6.17904 -23.97889,-6.17904 l -4.38853,20.54999 c 0,0 11.81508,5.21942 27.50142,5.21942 23.24983,0 41.54468,-11.56345 41.54468,-32.27613 0,-24.67793 -33.84429,-26.24304 -33.84429,-37.13276 0,-3.86982 4.64745,-8.10998 14.28902,-8.10998 10.87866,0 19.75422,4.49384 19.75422,4.49384 l 4.2949,-19.84783 c 0,0 -9.65737,-4.16617 -23.27673,-4.16617 z m -194.5578574,1.49795 -0.51492007,2.9959 c 0,0 8.94639137,1.63734 17.00406347,4.90344 10.374929,3.74527 11.113995,5.92556 12.8613,12.69747 l 19.040339,73.39951 H 74.929346 L 114.25052,101.49875 H 88.785375 l -25.26619,63.9086 -10.310105,-54.17193 c -0.945527,-6.19993 -5.73492,-9.73667 -11.597402,-9.73667 z m 123.4754874,0 -19.97655,93.99632 h 24.28316 l 19.90633,-93.99632 z m 135.43568,0 c -5.85557,0 -8.95804,3.13496 -11.23462,8.61321 l -35.5763,85.38311 h 25.46513 l 4.92686,-14.23053 h 31.02393 l 2.9959,14.23053 h 22.46924 l -19.60208,-93.99632 z m 3.31187,25.39492 7.54826,35.27202 h -20.22232 z"
          fill="#1434cb"
          fillOpacity={1}
          stroke="none"
          strokeWidth={0.299796}
          transform="translate(675,20) scale(0.80)"
        />
      </g>
    );
  }
  else if (props.type === 'uatp') {
    return (
      <g>
        <path
          d="m17.818 44.217c0.39848-0.1589 3.6482-1.1932 4.2366-1.3519 0 0-0.24999 0.65177-0.30474 0.82426-0.07547 0.23779-1.0251 0.33816-1.666 0.41515-1.0048 0.1207-2.5745 0.23561-2.2659 0.11255zm9.5957-2.0311c0.17567-0.46704 0.28503-0.93281 0.38993-1.035s1.5859-0.90373 3.1066-1.6627c2.7236-1.3592 5.4001-2.86 6.0269-3.2289 0.47119-0.27724 1.3465-0.88351 2.7049-1.7815l2.4698-1.6327h6.2603l0.05508 0.49903c-0.044 0.38254-0.57331 0.58035-2.5208 1.7465-5.9014 3.5338-11.342 5.9619-16.565 7.3935-1.1054 0.30296-2.1634 0.55084-2.2287 0.55084-0.06525 0 0.12527-0.38212 0.30094-0.84916zm22.857-13.837s4.7355-1.9491 6.3105-2.2731c0.8896-0.18297 2.3089-0.42325 3.154-0.53396 1.9568-0.25634 7.2182-0.25496 9.2194 0.0023 1.6948 0.21796 4.477 0.74942 5.2986 1.0121 0.83824 0.26804 0.46318 0.43491-0.56251 0.25027-0.51432-0.09259-2.3908-0.16965-4.17-0.17126-3.4296-0.0031-4.8684 0.29591-7.9396 1.0903-3.1596 1.0607-1.7891 0.62795-6.2626 0.62329-3.2933-0.0036-4.636 0.1007-5.0478 0z"
          fill="#4ab648"
          stroke-width={0.16174}
          transform="translate(675,20) scale(3.0)"
        />
        <path
          d="m6.9513 49.242c-2.9512-0.47825-5.0484-1.7685-6.0331-3.7117-0.79962-1.578-0.86458-2.3292-0.86757-10.033l-0.0027441-7.1018h5.0544l0.067017 6.7844c0.049101 4.9707 0.1227 6.971 0.27532 7.4825 0.28739 0.96314 1.3093 1.9946 2.2208 2.2417 0.70452 0.19093 3.6103 0.12332 4.1854-0.0974 0.2338-0.08971 0.25817-0.86913 0.25817-8.2551v-8.1561h5.2395l-0.04087 9.9547-0.04087 9.9547-0.87285 0.19767c-2.4671 0.5587-7.9215 0.98568-9.4426 0.73919zm12.762-0.56865c1.8985-4.4711 3.5758-9.2069 5.0504-13.017l2.8159-7.2605h6.2048l1.4615 3.7823c0.80383 2.0803 1.5416 4.0594 1.5416 4.1532 0 0.14932-2.4532 1.4154-3.8175 2.1091l-0.48398 0.2461-0.75431-2.1418c-0.41487-1.178-0.82804-2.3329-0.91814-2.5665-0.14866-0.38543-0.27083-0.13076-1.3198 2.7512-1.3658 3.2388-2.5106 6.8765-3.623 9.9168l-0.85524 2.3011-5.4427 0.08682zm15.283-2.9397c-0.63514-1.8112-1.1527-3.3466-1.15-3.412 0.0026-0.06546 0.09528-0.08155 0.19005-0.11902 0.152-0.0601 1.0969-0.44197 2.2444-0.88199 1.1504-0.4411 2.153-0.77887 2.153-0.77887 0.06069 0.0722 0.72361 1.6886 1.4443 3.5653 0.72067 1.8766 1.4438 3.7513 1.6068 4.1659l0.29653 0.75382h-5.6303zm13.331-4.7975 0.04521-8.0905h-6.2601l-2.07e-4 -2.2678v-2.2286l3.0048-0.02438c1.6465-0.01336 5.5901 0.01771 8.7471 0.02009l5.6966 0.0043v4.4832l-3.055 0.0431-3.0691-0.02993-0.02695 8.127-0.04112 8.054h-5.0865zm15.677-2.133v-10.224l0.43642-0.08881c2.1422-0.43588 7.2874-0.53579 8.9923-0.1746 3.6346 0.76998 5.657 3.0502 5.9119 6.6655 0.35208 4.9942-2.8898 8.0018-8.6355 8.0116l-1.6267 0.0027v6.0306h-5.0784zm8.6648-0.55306c0.91648-0.41621 1.3815-1.1347 1.4629-2.2603 0.08356-1.1553-0.02119-1.5689-0.55949-2.2086-0.67605-0.80344-1.4947-1.093-3.1013-1.0971l-1.3886-0.0036v5.8719l1.468-0.0036c1.087-0.0027 1.6368-0.08015 2.1185-0.29891z"
          fill="#fff"
          strokeWidth={0.1587}
          transform="translate(675,20) scale(3.0)"
        />
      </g>
    );
  }
  // TODO amex, etc

  return null;
};

const CreditCard = props => (
  <div>
    <svg
      viewBox="0 0 1000 630"
      width="350px"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <path
          id="credit-card_svg__j"
          d="M100.311 498.264h832.084v97.022H100.311z"
        />
        <path
          id="credit-card_svg__i"
          d="M100.311 498.264h832.084v97.022H100.311z"
        />
        <path
          id="credit-card_svg__g"
          d="M100.311 498.264H930.75v57.555H100.311z"
        />
        <path
          id="credit-card_svg__h"
          d="M100.311 498.264H930.75v57.555H100.311z"
        />
        <linearGradient id="credit-card_svg__a">
          <stop offset={0} stopColor="#2ca2c7" />
          <stop offset={1} stopColor="#3481ba" />
        </linearGradient>
        <linearGradient
          id="credit-card_svg__b"
          x1={0.767}
          x2={31.381}
          y1={3.509}
          y2={28.03}
          gradientTransform="scale(1.05705 .94603)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#DDD" />
          <stop offset="100%" stopColor="#BABABA" />
          <stop offset="100%" stopColor="#B8B8B8" />
        </linearGradient>
        <linearGradient
          xlinkHref="#credit-card_svg__b"
          id="credit-card_svg__f"
          gradientUnits="userSpaceOnUse"
          gradientTransform="scale(1.05705 .94603)"
          x1={0.767}
          y1={3.509}
          x2={31.381}
          y2={28.03}
        />
        <radialGradient
          xlinkHref="#credit-card_svg__a"
          id="credit-card_svg__c"
          cx={500}
          cy={315}
          fx={500}
          fy={315}
          r={499.501}
          gradientTransform="matrix(1.67273 1.49985 -.89025 .99403 -55.437 -747.546)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          xlinkHref="#credit-card_svg__a"
          id="credit-card_svg__e"
          cx={500}
          cy={315}
          fx={500}
          fy={315}
          r={499.501}
          gradientTransform="matrix(1.67273 1.49985 -.89025 .99403 -55.936 -748.045)"
          gradientUnits="userSpaceOnUse"
        />
        <clipPath clipPathUnits="userSpaceOnUse" id="credit-card_svg__d">
          <path d="M0 867.397h867.397V0H0z" />
        </clipPath>
      </defs>
      <rect
        style={{
          mixBlendMode: "normal",
        }}
        width={1000}
        height={630}
        x={0.499}
        y={0.499}
        ry={45.421}
        fill="url(#credit-card_svg__c)"
      />
      <path d="M27.202 139.7l15.065 31.011 25.108-16.48z" fill="#039ddb" />
      <path d="M59.564 92.74l7.811 61.49-40.173-14.53z" fill="#30ade3" />
      <path d="M40.035 177.8l2.232-7.089 25.108-16.48z" fill="#0092d6" />
      <path d="M1.163 191.976l38.872-14.177 2.232-7.088z" fill="#a2defa" />
      <path d="M93.042 83.347l-25.667 70.884-7.811-61.492z" fill="#81caed" />
      <path d="M106.247 174.078L67.375 154.23l25.667-70.884z" fill="#039ddb" />
      <path d="M182.794 176.83L93.042 83.347l13.205 90.73z" fill="#30ade3" />
      <path d="M114.059 221.924l68.735-45.094-76.547-2.752z" fill="#0092d6" />
      <path d="M252.25 131.193L93.041 83.347l89.752 93.483z" fill="#81caed" />
      <path d="M272.522 143.775l-44.219 31.012 23.946-43.594z" fill="#039ddb" />
      <path d="M217.097 195.343l35.152-64.15-138.19 90.731z" fill="#8dd8f8" />
      <path d="M219.472 248.423l34.823-23.132-37.198-29.948z" fill="#30ade3" />
      <path d="M267.315 179.749l29.758 17.012-42.778 28.53z" fill="#81caed" />
      <path d="M319.95 244.607l-22.877-47.846-77.601 51.662z" fill="#8dd8f8" />
      <path d="M222.305 311.592l97.645-66.985-100.478 3.816z" fill="#039ddb" />
      <path d="M114.059 221.924l108.246 89.668-5.208-116.25z" fill="#0092d6" />
      <path d="M105.875 292.808l116.43 18.784-108.246-89.668z" fill="#30ade3" />
      <path d="M226.769 328.958l3.668-22.946-8.132 5.58z" fill="#a2defa" />
      <path d="M178.97 318.326l43.335-6.734-39.21-6.326z" fill="#0092d6" />
      <path d="M167.996 354.653l15.1-49.387-77.22-12.458z" fill="#039ddb" />
      <path d="M136.936 333.92l-6.138-16.126-6.696-6.734z" fill="#a2defa" />
      <path d="M148.281 348.983l19.715 5.67-18.971-18.961z" fill="#8dd8f8" />
      <path d="M248.158 174.964l13.205-.709-9.858-11.164z" fill="#a2defa" />
      <path d="M235.143 387.613l-60.55-54.626-6.597 21.666z" fill="#0092d6" />
      <path d="M236.626 376.804l-1.483 10.809-29.786-26.913z" fill="#a2defa" />
      <path d="M206.682 341.363l-5.56 15.565-7.968-7.172z" fill="#61bdec" />
      <path d="M196.824 341.717l9.815-.268-13.485 8.307z" fill="#a2defa" />
      <path d="M221.561 336.4l14.135 10.988 10.23-2.481z" fill="#61bdec" />
      <path d="M251.877 353.59l10.974-3.012-13.95-3.19z" fill="#81caed" />
      <path
        d="M233.836 398.778c.605-7.398 1.837-14.54 2.79-21.974l45.01-2.303z"
        fill="#61bdec"
      />
      <path d="M220.073 432.093l13.763-33.315 23.25 61.314z" fill="#0092d6" />
      <path d="M281.636 374.5l-24.55 85.592-23.25-61.314z" fill="#a2defa" />
      <path d="M319.95 403.031l-38.314-28.53-11.449 39.947z" fill="#30ade3" />
      <path d="M324.786 490.218l-4.836-87.187-49.763 11.417z" fill="#0092d6" />
      <path d="M359.752 422.524l-34.966 67.694-4.836-87.187z" fill="#30ade3" />
      <path d="M350.08 472.32l9.672-49.796-28.38 54.935z" fill="#039ddb" />
      <path d="M306.187 464.345l-49.102-4.253 13.102-45.644z" fill="#30ade3" />
      <path d="M257.83 515.381l48.357-51.036-49.102-4.253z" fill="#a2defa" />
      <path d="M324.786 490.218l-66.957 25.163 48.358-51.036z" fill="#30ade3" />
      <path d="M258.387 575.81l-.558-60.429 66.957-25.163z" fill="#039ddb" />
      <path d="M284.612 598.492l-1.729-54.262-24.496 31.58z" fill="#0092d6" />
      <path d="M194.035 84.233l58.214 46.96-77.899-23.404z" fill="#a2defa" />
      <path d="M202.776 69.702l5.58 10.101 17.297-16.835z" fill="#30ade3" />
      <path d="M232.348 64.74l6.138 4.253 5.952-11.341z" fill="#a2defa" />
      <path d="M217.841 74.487l9.01 6.505-11.428 9.09z" fill="#81caed" />
      <path d="M235.51 74.132l-20.087 15.95 24.365-1.064z" fill="#30ade3" />
      <path d="M221.375 98.587l10.416.355-5.766 6.91z" fill="#0092d6" />
      <path d="M243.508 87.069l11.16 9.746-2.419-17.898z" fill="#81caed" />
      <path d="M231.977 107.448l10.043 10.81 4.278-17.013z" fill="#30ade3" />
      <path
        d="M253.923 101.777l9.672 4.253-16.367 13.113zM272.894 108.334l-17.11 20.91 48.17 22.328z"
        fill="#a2defa"
      />
      <path d="M292.61 114.181l-19.716-5.847 31.06 43.238z" fill="#30ade3" />
      <path d="M315.672 163.268l-11.717-11.696-6.696 34.556z" fill="#8dd8f8" />
      <path d="M285.013 142.79l18.942 8.782-6.696 34.556z" fill="#61bdec" />
      <path d="M269.918 170.002l27.341 16.126-7.812-27.644z" fill="#0092d6" />
      <path d="M337.99 33.906l-40.173 9.746 58.029 2.481z" fill="#8dd8f8" />
      <path d="M285.914 103.903l69.932-57.77-58.029-2.48z" fill="#81caed" />
      <path d="M262.665 100.536l35.152-56.884-11.903 60.251z" fill="#30ade3" />
      <path d="M255.04 55.88l42.777-12.228-35.152 56.884z" fill="#a2defa" />
      <path d="M348.778 200.836l-14.693-21.973 39.244-13.291z" fill="#0092d6" />
      <path d="M413.689 152.104l-66.213 1.595-13.391 25.164z" fill="#81caed" />
      <path d="M339.479 106.03l74.21 46.074-66.213 1.595z" fill="#039ddb" />
      <path d="M315.114 88.84l24.365 17.19 20.273-53.34z" fill="#8dd8f8" />
      <path d="M415.177 42.766l-75.698 63.264 20.273-53.34z" fill="#0092d6" />
      <path d="M413.689 152.104l1.488-109.338-75.698 63.264z" fill="#30ade3" />
      <path
        d="M444.75 70.234l-29.573-27.468-1.488 91.617zM431.544 172.483l-12.276 15.949 15.438-7.443z"
        fill="#039ddb"
      />
      <path d="M407.18 177.445l12.088 10.987 12.276-15.949z" fill="#a2defa" />
      <path d="M502.034 111.878l4.278-20.91-20.273-4.077z" fill="#30ade3" />
      <path d="M514.31 107.093l4.091-9.392-10.043-2.658z" fill="#039ddb" />
      <path d="M512.45 90.79l7.811-9.215-19.157-2.48z" fill="#81caed" />
      <path d="M623.485 372.906l-66.563 43.113-31.64 95.995z" fill="#039ddb" />
      <path d="M592.797 448.928l-4.94-25.559-18.244 42.55z" fill="#0092d6" />
      <path d="M575.128 479.054l-5.515-13.135-17.548 40.956z" fill="#61bdec" />
      <path d="M525.283 512.014l62.575-88.645-35.793 83.506z" fill="#30ade3" />
      <path d="M618.464 442.726l-8.928 38.809-7.811-24.1z" fill="#61bdec" />
      <path d="M622.741 450.7l-4.277-7.974-8.928 38.809z" fill="#039ddb" />
      <path d="M598.377 481.18l11.16.355-5.158-15.923z" fill="#30ade3" />
      <path d="M505.196 463.814l20.087 48.2 31.639-95.995z" fill="#61bdec" />
      <path d="M511.52 445.384l45.402-29.365-51.726 47.795z" fill="#a2defa" />
      <path
        d="M497.942 396.297l125.543-23.391-111.966 72.478z"
        fill="#30ade3"
      />
      <path d="M557.645 309.288l45.868 67.346-105.57 19.663z" fill="#81caed" />
      <path d="M491.433 291.922l66.212 17.366-32.92 48.378z" fill="#61bdec" />
      <path d="M417.037 364.223l107.688-6.557-33.292-65.744z" fill="#30ade3" />
      <path d="M497.942 396.297l26.783-38.631-107.688 6.557z" fill="#039ddb" />
      <path d="M439.727 393.816l34.703-6.847-57.393-22.746z" fill="#0092d6" />
      <path d="M435.45 303.795l55.983-11.873-74.396 72.3z" fill="#a2defa" />
      <path d="M441.346 292.153l16.965-.752-17.886-17.167z" fill="#0092d6" />
      <path d="M453.577 257.944l4.734 33.457 23.015-22.68z" fill="#30ade3" />
      <path d="M455.286 270.1l-14.86 4.134 17.885 17.167z" fill="#81caed" />
      <path d="M453.577 257.944l62.47 24.31-34.72-47.24z" fill="#a2defa" />
      <path d="M455.418 211.08l16.834 23.683-15.913 11.403z" fill="#81caed" />
      <path
        d="M469.49 242.281l2.762-7.518-15.913 11.403zM449.894 224.864l-11.704 14.66 12.493-3.257z"
        fill="#30ade3"
      />
      <path d="M440.688 228.874l9.206-4.01-11.704 14.66z" fill="#a2defa" />
      <path d="M504.868 231.004l-3.019 31.883-20.523-27.873z" fill="#8dd8f8" />
      <path d="M490.532 218.473l-9.206 16.54 15.782-2.63z" fill="#81caed" />
      <path d="M548.004 203.311l-46.155 59.576 3.019-31.883z" fill="#30ade3" />
      <path d="M547.347 279.121l-45.498-16.234 25.061-32.354z" fill="#0092d6" />
      <path d="M547.347 279.121l.657-75.81-21.094 27.222z" fill="#81caed" />
      <path d="M533.932 291.777l13.415-12.656-31.322-11.183z" fill="#30ade3" />
      <path d="M530.381 205.442l17.623-2.13-22.489 14.66z" fill="#81caed" />
      <path d="M507.892 224.112l11.763-48.189-27.676 35.533z" fill="#0092d6" />
      <path d="M477.775 198.55l14.204 12.906 4.155-27.446z" fill="#a2defa" />
      <path d="M483.957 215.215l8.022-3.759-8.285-7.518z" fill="#8dd8f8" />
      <path d="M491.98 211.456l5.917-39.22 21.758 3.687z" fill="#61bdec" />
      <path d="M530.776 147.425l-32.879 24.81 32.484 5.514z" fill="#81caed" />
      <path d="M522.096 198.675l25.908 4.636-17.623-25.562z" fill="#8dd8f8" />
      <path d="M559.397 183.696l-11.393 19.615-17.623-25.562z" fill="#30ade3" />
      <path d="M559.397 183.696l-28.621-36.27-.395 30.323z" fill="#039ddb" />
      <path d="M567.995 162.086l-37.22-14.66 16.309 20.675z" fill="#a2defa" />
      <path d="M562.471 173.113l5.524-11.027-20.911 6.015z" fill="#039ddb" />
      <path d="M548.004 203.311l25.909-44.608 26.303.125z" fill="#8dd8f8" />
      <path d="M585.75 139.03l15.386 5.137-7.11-16.682z" fill="#0092d6" />
      <path d="M585.75 139.03l27.88-38.845-20.78 10.275z" fill="#30ade3" />
      <path d="M609.553 94.546l4.077 5.64-20.78 10.274z" fill="#a2defa" />
      <path d="M600.61 222.232l-52.606-18.92-.595 68.235z" fill="#039ddb" />
      <path d="M548.004 203.311l110.078 39.597-57.866-84.08z" fill="#30ade3" />
      <path d="M600.61 222.232l-39.562 36.666 50.873 31.375z" fill="#30ade3" />
      <path d="M600.61 222.232l49.581 106.134 7.891-85.458z" fill="#8dd8f8" />
      <path d="M600.61 222.232l5.918 35.712 8.154-5.764z" fill="#81caed" />
      <path d="M557.645 309.288l31.04-33.355-17.929 45.667z" fill="#a2defa" />
      <path d="M588.686 275.933l-16.247 17.517-22.988-16.208z" fill="#039ddb" />
      <path d="M546.426 292.278l3.025-15.036 22.988 16.208z" fill="#8dd8f8" />
      <path d="M611.92 290.273l-23.234-14.34-17.93 45.667z" fill="#61bdec" />
      <path d="M604.95 367.21l-34.194-45.61 41.165-31.327z" fill="#30ade3" />
      <path d="M604.95 367.21l4.666-51.576 22.163 41.302z" fill="#0092d6" />
      <path d="M631.78 356.936l-12.45-23.182 31.782 2.256z" fill="#30ade3" />
      <path d="M609.616 315.634l24.966-20.694-22.661-4.667z" fill="#a2defa" />
      <path d="M650.191 328.366l-40.575-12.732 24.966-20.694z" fill="#039ddb" />
      <path d="M650.191 328.366l78.91 19.046-71.019-104.504z" fill="#61bdec" />
      <path d="M709.11 382.749l19.99-35.337-52.614-12.7z" fill="#039ddb" />
      <path d="M715.291 389.515l-.526-11.528 5.787 7.142z" fill="#0092d6" />
      <path d="M774.604 222.358L729.1 347.412l-42.874-63.028z" fill="#30ade3" />
      <path d="M600.216 158.828l27.486 39.972 46.087-30.108z" fill="#039ddb" />
      <path d="M631.648 123.367l-31.432 35.461 44.715 6.015z" fill="#81caed" />
      <path d="M673.789 168.692l-28.858-3.85 36.56-94.605z" fill="#0092d6" />
      <path d="M636.777 123.116l44.715-52.879-29.196 75.81z" fill="#61bdec" />
      <path d="M627.702 198.8l179.65-117.41 39.322 90.344z" fill="#a2defa" />
      <path d="M673.789 168.692l61.887-40.313-54.184-58.142z" fill="#8dd8f8" />
      <path d="M681.492 70.237l28.144 30.199 7.233-23.683z" fill="#61bdec" />
      <path d="M735.676 128.379l-26.04-27.943 75.157-4.302z" fill="#0092d6" />
      <path d="M709.636 100.436l55.5-3.008-7.629-11.402z" fill="#61bdec" />
      <path d="M670.05 71.74l8.68-7.643-10.39-6.766z" fill="#a2defa" />
      <path d="M665.71 64.974l-25.514-21.427v16.29z" fill="#039ddb" />
      <path d="M758.297 58.584l13.809 13.783 9.074-13.783z" fill="#a2defa" />
      <path d="M781.97 80.512l11.178-1.629-9.338-6.265z" fill="#039ddb" />
      <path d="M807.352 81.39l-17.39 11.38 1.476-11.005z" fill="#81caed" />
      <path d="M868.374 87.78l-21.7 83.954-39.322-90.345z" fill="#30ade3" />
      <path d="M936.368 77.505L868.374 87.78l-21.7 83.954z" fill="#a2defa" />
      <path d="M874.424 76.377l61.944 1.128-53.426 8.087z" fill="#8dd8f8" />
      <path d="M921.77 152.563l14.598-75.058-44.657 46.903z" fill="#61bdec" />
      <path d="M876.134 169.228l15.577-44.82-45.037 47.326z" fill="#81caed" />
      <path d="M891.71 124.408l-7.437 21.388 30.936.619z" fill="#039ddb" />
      <path d="M895.992 169.103l19.217-22.688-15.271-.306z" fill="#0092d6" />
      <path d="M892.573 184.892l3.42-15.789 16.702 38.97z" fill="#039ddb" />
      <path d="M912.695 208.073l-16.703-38.97 9.163-10.75z" fill="#8dd8f8" />
      <path d="M915.72 186.02l-3.025 22.053-5.513-36.355z" fill="#81caed" />
      <path d="M860.089 200.053l-45.504-6.014 6.845 74.365z" fill="#039ddb" />
      <path d="M774.604 222.358l40.136-28.208 12.076 134.09z" fill="#a2defa" />
      <path d="M846.674 171.734L814.74 194.15l27.463 3.523z" fill="#0092d6" />
      <path d="M826.816 328.24l-3.42-37.967 13.152 18.796z" fill="#039ddb" />
      <path d="M774.604 222.358l-40 109.893 92.212-4.01z" fill="#8dd8f8" />
      <path d="M627.702 198.8l218.972-27.066-160.448 112.65z" fill="#81caed" />
      <path d="M860.089 200.053l-38.659 68.351 40.106-17.1z" fill="#30ade3" />
      <path d="M821.43 268.404l26.792-11.43 3.318 34.427z" fill="#0092d6" />
      <path d="M860.089 200.053l1.447 51.25 6.97-27.567z" fill="#039ddb" />
      <path d="M877.449 238.021l-13.94-38.218 13.414 17.041z" fill="#a2defa" />
      <path d="M877.843 243.033l1.053 18.044 13.546-12.906z" fill="#61bdec" />
      <path d="M872.32 295.16l7.496-31.326 8.023 21.176z" fill="#8dd8f8" />
      <path d="M879.816 263.834l8.023 21.176-1.842-24.434z" fill="#30ade3" />
      <path d="M872.32 295.16l3.447-14.41-18.045 16.666z" fill="#039ddb" />
      <path d="M826.816 328.24l-76.474 3.316 24.632 35.325z" fill="#30ade3" />
      <path
        d="M750.342 331.556l15.054 21.591-11.16 4.519zM774.974 366.88l20.18-15.062-1.209 27.202z"
        fill="#0092d6"
      />
      <path d="M795.154 351.818l-1.209 27.202 10.509-10.101z" fill="#61bdec" />
      <path d="M831.98 335.426l7.16 3.013-2.603-12.405z" fill="#a2defa" />
      <path d="M835.7 362.982l17.297 9.304-15.437-24.278z" fill="#8dd8f8" />
      <path d="M842.675 384.336l12.461 5.936.465-12.67z" fill="#039ddb" />
      <path d="M837.467 424.208l10.322-15.506-12.368 3.101z" fill="#a2defa" />
      <path d="M810.963 417.208l17.111-31.277-.93 33.315z" fill="#30ade3" />
      <path d="M810.963 417.208l17.111-31.277-24.178 18.695z" fill="#81caed" />
      <path d="M828.074 385.93l-.667 23.935 6.991-20.479z" fill="#039ddb" />
      <path d="M762.234 390.095l32.455 22.771-3.348 13.468z" fill="#8dd8f8" />
      <path d="M844.814 439.89l14.507-10.189-62.958-1.86z" fill="#039ddb" />
      <path d="M774.974 366.88l-9.578-13.733 6.788 31.366z" fill="#30ade3" />
      <path d="M772.184 384.513l14.229 4.164 1.395 12.76z" fill="#61bdec" />
      <path d="M772.184 384.513l1.395-8.595 7.347 11.165z" fill="#a2defa" />
      <path d="M869.643 407.816l47.149 11.961-10.695 16.835z" fill="#61bdec" />
      <path
        d="M928.044 437.41l-21.947-.798 10.695-16.835zM983.844 564.567l14.993-17.668-15.124-17.794z"
        fill="#039ddb"
      />
      <path d="M949.124 582.485l8.943 6.641 19.728-28.068z" fill="#61bdec" />
      <path d="M891.784 560.244l5.787 6.891 5.852-14.034z" fill="#30ade3" />
      <path d="M891.784 560.244l11.64-7.143-11.18-1.128z" fill="#81caed" />
      <path d="M813.927 522.088l112.708-40.474-112.576-6.14z" fill="#61bdec" />
      <path d="M926.635 481.614l-67.896 24.377 33.703 36.898z" fill="#30ade3" />
      <path d="M926.635 481.614l-34.193 61.275 42.347-47.115z" fill="#039ddb" />
      <path d="M910.46 543.14l24.33-47.366-42.348 47.115z" fill="#0092d6" />
      <path d="M926.635 481.614L914.01 461.44l-99.951 14.035z" fill="#a2defa" />
      <path d="M814.059 475.475l83.434-11.716-39.245-13.47z" fill="#8dd8f8" />
      <path d="M897.493 463.76l-31.885-10.945 11.71-10.672z" fill="#039ddb" />
      <path d="M897.493 463.76l16.517-2.32-8.022-20.926z" fill="#61bdec" />
      <g
        clipPath="url(#credit-card_svg__d)"
        transform="matrix(4.68642 0 0 -4.68642 -1299.552 2382.915)"
        opacity={0.12}
        fill="#0046ad"
      >
        <path d="M388.592 447.405c-.43-.443-.654-1.351-.544-1.97.085-.477.834-1.163 1.294-1.168.613-.007 1.39.419 1.818.905.986 1.118 1.807 2.384 2.806 3.74-2.176.376-3.973-.065-5.374-1.507m26.954 13.218c-4.124-1.323-7.606-3.75-10.77-6.82l8.138-.902 2.632 7.722m-30.366-41.12c.946-.525 1.875-1.082 2.84-1.57 1.599-.804 3.156-.755 4.426.598 1.123 1.199 2.35 2.389 3.126 3.804 2.912 5.306 1.169 10.8-4.006 13.132-3.562 1.603-8.275.493-11.512-2.6-1.014-.97-1.317-1.835-.458-3.038 1.124-1.575 2.18-3.2 3.518-5.174-2.075 1.188-3.807 2.137-5.497 3.158-2.011 1.214-3.678 2.696-4.551 5.028-.608 1.624-1.596 3.042-3.296 3.933-1.576.825-1.453 3.094.189 3.943 2.682 1.389 4.91 3.25 7.082 5.36 7.288 7.08 16.037 11.267 26.182 12.454.696.082 1.444.437 1.999.878a39.668 39.668 0 0013.384 7.009c.604.18 1.23.295 2.047.487-1.442-3.65-2.48-7.143-2.603-10.786.188-.1.23-.14.272-.141.188-.003.377.003.566.009 6.142.17 11.723-4.57 17.049-11.72 16.717-22.45-.772-44.068-14.757-53.502-2.28-1.815-4.782-3.283-7.693-4.336 3.584 5.927-16.985 16.105-22.493 23.062 13.666.557 33.04.557 34.627 21.258.182 4.37-2.563 10.05-5.086 11.336.182-.321.309-.562.45-.796 4.055-6.69 3.026-14.795-2.743-20.056-2.694-2.455-5.682-4.265-9.733-3.475-2.895.563-5.581-.417-7.873-2.403-2.778-2.408-6.094-3.59-9.73-3.845-.52-.036-1.302.234-1.572.63-1.592 2.328-3.067 4.735-4.582 7.115l.428.248" />
        <path d="M402.528 381.98c-.885 3.864-2.417 7.064-5.359 9.468-8.607 7.033-21.245 2.973-24.056-7.805-.387-1.487-.896-1.66-2.247-1.242-4.677 1.444-9.166 3.286-13.446 5.835 4.333 7.3 4.218 14.242-2.028 20.296-4.959 4.806-11.19 4.965-19.03 1.018-1.908 2.027-5.628 10.772-6.357 15.022 8.492 2.22 13.51 7.525 12.728 16.57-.642 7.413-5.427 11.755-12.797 13.418 1.234 5.404 3.43 10.333 6.241 15.15 7.462-4.37 14.605-4.327 20.483 2.345 5.104 5.793 4.778 12.319.75 18.85 3.53 2.269 7.341 3.836 11.257 5.168 1.185.403 2.635 1.225 3.552.85.79-.322 1.017-2.068 1.45-3.201 2.2-5.76 8.27-9.756 14.44-9.491 6.48.278 12.208 4.789 13.885 10.938.164.602.315 1.207.534 2.05 1.241-.355 2.461-.596 3.595-1.052 3.107-1.25 6.171-2.602 9.263-3.885.876-.363.985-.946.71-1.748-3.743-10.884-11.143-17.787-22.389-20.39-2.076-.48-4.262-.615-6.403-.666-14.95-.361-26.925-10.767-29.322-25.555-2.273-14.017 6.636-28.453 20.347-32.65 2.87-.878 5.947-1.361 8.95-1.475 12.447-.464 21.554-6.076 27.246-17.16.665-1.296 1.135-2.707 1.55-4.108.12-.403-.119-1.21-.444-1.401-4.05-2.36-8.404-3.966-13.103-5.148" />
      </g>
      <rect
        style={{
          mixBlendMode: "normal",
        }}
        width={1000}
        height={630}
        ry={45.421}
        opacity={0.7}
        fill="url(#credit-card_svg__e)"
      />
      {props.type !== 'uatp' && <g fill="none">
        <path
          fill="#949494"
          d="M126.793 312.052v-71.574c0-10.687 8.675-19.107 19.352-19.107h84.078c10.677 0 19.351 8.744 19.351 19.107v71.574c0 10.687-8.674 19.107-19.351 19.107h-84.078c-10.677 0-19.352-8.42-19.352-19.107z"
        />
        <path
          fill="url(#credit-card_svg__f)"
          d="M11.357 27.824v1.575H5.95c-1.442 0-2.794-.613-3.696-1.575zm20.372 0c-.992.962-2.254 1.575-3.696 1.575h-5.408v-1.575zm-14.783-5.162l5.228 4.987v1.662H11.808V27.65zm5.769-1.838c.27.35.63.525.991.525h9.465v2.975c0 1.138-.45 2.187-1.082 3.062h-9.645l-5.318-5.074v-1.488zm-6.04 0v1.488l-5.228 5.074H1.893C1.172 26.511.81 25.462.81 24.324V21.35h9.374c.451 0 .812-.175.992-.525zm-5.768-5.775v5.163c0 .35-.36.7-.722.612H.811V15.05zm22.174-.175v5.95h-9.375c-.36 0-.63-.262-.63-.612v-5.338zM21.994.437V1.75L20.1 3.675l.36.35L22.354 2.1h9.375c.811.962 1.352 2.1 1.352 3.412v2.625h-9.375c-.54 0-1.081.525-1.081 1.138v10.937H11.357V9.1h5.86V7.087l2.433-2.362-.36-.35-2.344 2.362-5.138-5.075V.437zM10.276 8.575c.36 0 .63.262.63.612v5.425H.812V8.575zm22.895 0v5.95H23.075v-5.25c0-.438.27-.7.631-.7zM11.538 2.187l5.138 5.075V8.75h-5.499c-.18-.35-.54-.613-.992-.613v.088H.811V5.6c0-1.313.54-2.538 1.352-3.413zM28.033.437c1.262 0 2.434.438 3.335 1.225h-8.833V.437zm-16.676 0v1.225H2.614C3.515.875 4.687.437 5.949.437z"
          transform="matrix(3.70141 0 0 3.70141 125.459 221.047)"
        />
      </g>}
      <text
        transform="translate(68.091 2.849)"
        fontWeight={400}
        fontSize={40}
        fontFamily="JetBrains Mono"
        fill="#28262d"
      >
        <tspan x={100.311} y={534.173}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{props.expiry}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{props.cvv}</tspan>
      </text>
      {props.type === 'uatp' ?
        <g fill="#ededed">
          <path d="m170.09 535.82v-29.2h17.16v3.84h-12.92v8.28h11.52v3.8h-11.52v9.44h12.92v3.84z" style={{whiteSpace:"pre"}} />
          <path d="m191.69 535.82 8.24-14.88-7.76-14.32h4.88l4.08 7.96q0.36 0.76 0.72 1.52t0.56 1.16q0.16-0.4 0.48-1.16 0.36-0.76 0.76-1.52l4.16-7.96h4.68l-7.76 14.16 8.24 15.04h-4.88l-4.52-8.64q-0.4-0.76-0.76-1.52-0.36-0.8-0.56-1.24-0.16 0.44-0.52 1.24-0.36 0.76-0.72 1.48l-4.6 8.68z" style={{whiteSpace:"pre"}} />
          <path d="m217.69 535.82v-29.2h9.56q2.84 0 4.92 1.08 2.12 1.08 3.24 3.08 1.16 1.96 1.16 4.64t-1.16 4.68q-1.16 1.96-3.24 3.04t-4.92 1.08h-5.24v11.6zm4.32-15.48h5.24q2.24 0 3.56-1.32 1.36-1.36 1.36-3.6t-1.36-3.56q-1.32-1.36-3.56-1.36h-5.24z" style={{whiteSpace:"pre"}} />
          <path d="m242.25 535.82v-3.84h5.88v-21.52h-5.88v-3.84h16.2v3.84h-5.92v21.52h5.92v3.84z" style={{whiteSpace:"pre"}} />
          <path d="m265.69 535.82v-29.2h9.16q2.72 0 4.76 1.08 2.08 1.04 3.2 2.96 1.16 1.92 1.16 4.52 0 2.92-1.52 5.08-1.48 2.12-4 3l5.92 12.56h-4.92l-5.32-12h-4.12v12zm4.32-15.84h4.84q2.16 0 3.44-1.28t1.28-3.44q0-2.2-1.32-3.48-1.28-1.32-3.4-1.32h-4.84z" style={{whiteSpace:"pre"}} />
          <path d="m296.17 535.82v-10.76l-8.68-18.44h4.48l5.16 11.04q0.52 1.08 0.84 2.04t0.44 1.44q0.12-0.48 0.44-1.44t0.8-2.04l5.04-11.04h4.48l-8.68 18.44v10.76z" style={{whiteSpace:"pre"}} />
          <path d="m322.33 519.78q-1.6 0-2.56-0.88t-0.96-2.32q0-1.4 0.96-2.28t2.56-0.88 2.56 0.88 0.96 2.28q0 1.44-0.96 2.32t-2.56 0.88zm0 16.44q-1.6 0-2.56-0.88t-0.96-2.32q0-1.4 0.96-2.28t2.56-0.88 2.56 0.88 0.96 2.28q0 1.44-0.96 2.32t-2.56 0.88z" style={{whiteSpace:"pre"}} />
        </g>
        :
        <path
          d="M170.086 535.817v-29.2h17.16v3.84h-12.92v8.28h11.52v3.8h-11.52v9.44h12.92v3.84zM191.686 535.817l8.24-14.88-7.76-14.32h4.88l4.08 7.96.72 1.52q.36.76.56 1.16.16-.4.48-1.16.36-.76.76-1.52l4.16-7.96h4.68l-7.76 14.16 8.24 15.04h-4.88l-4.52-8.64q-.4-.76-.76-1.52-.36-.8-.56-1.24-.16.44-.52 1.24-.36.76-.72 1.48l-4.6 8.68zM217.686 535.817v-29.2h9.56q2.84 0 4.92 1.08 2.12 1.08 3.24 3.08 1.16 1.96 1.16 4.64 0 2.68-1.16 4.68-1.16 1.96-3.24 3.04t-4.92 1.08h-5.24v11.6zm4.32-15.48h5.24q2.24 0 3.56-1.32 1.36-1.36 1.36-3.6t-1.36-3.56q-1.32-1.36-3.56-1.36h-5.24zM242.246 535.817v-3.84h5.88v-21.52h-5.88v-3.84h16.2v3.84h-5.92v21.52h5.92v3.84zM265.686 535.817v-29.2h9.16q2.72 0 4.76 1.08 2.08 1.04 3.2 2.96 1.16 1.92 1.16 4.52 0 2.92-1.52 5.08-1.48 2.12-4 3l5.92 12.56h-4.92l-5.32-12h-4.12v12zm4.32-15.84h4.84q2.16 0 3.44-1.28 1.28-1.28 1.28-3.44 0-2.2-1.32-3.48-1.28-1.32-3.4-1.32h-4.84zM296.166 535.817v-10.76l-8.68-18.44h4.48l5.16 11.04q.52 1.08.84 2.04.32.96.44 1.44.12-.48.44-1.44t.8-2.04l5.04-11.04h4.48l-8.68 18.44v10.76zM322.326 519.777q-1.6 0-2.56-.88t-.96-2.32q0-1.4.96-2.28.96-.88 2.56-.88t2.56.88q.96.88.96 2.28 0 1.44-.96 2.32-.96.88-2.56.88zm0 16.44q-1.6 0-2.56-.88t-.96-2.32q0-1.4.96-2.28.96-.88 2.56-.88t2.56.88q.96.88.96 2.28 0 1.44-.96 2.32-.96.88-2.56.88zM682.485 536.217q-4.12 0-6.56-2.28-2.4-2.32-2.4-6.24v-12.96q0-3.96 2.4-6.24 2.44-2.28 6.56-2.28 4.08 0 6.48 2.32 2.44 2.28 2.44 6.2h-4.32q0-2.28-1.24-3.48-1.2-1.2-3.36-1.2-2.2 0-3.44 1.2-1.2 1.2-1.2 3.44v13q0 2.28 1.2 3.48 1.24 1.2 3.44 1.2 2.16 0 3.36-1.2 1.24-1.2 1.24-3.48h4.32q0 3.92-2.44 6.24-2.4 2.28-6.48 2.28zM703.445 535.817l-7.4-29.2h4.44l4.68 19.4q.44 1.76.76 3.48.36 1.68.52 2.6.16-.92.48-2.6.32-1.72.72-3.48l4.64-19.4h4.36l-7.44 29.2zM727.444 535.817l-7.4-29.2h4.44l4.68 19.4q.44 1.76.76 3.48.36 1.68.52 2.6.16-.92.48-2.6.32-1.72.72-3.48l4.64-19.4h4.36l-7.44 29.2zM754.324 519.777q-1.6 0-2.56-.88t-.96-2.32q0-1.4.96-2.28.96-.88 2.56-.88t2.56.88q.96.88.96 2.28 0 1.44-.96 2.32-.96.88-2.56.88zm0 16.44q-1.6 0-2.56-.88t-.96-2.32q0-1.4.96-2.28.96-.88 2.56-.88t2.56.88q.96.88.96 2.28 0 1.44-.96 2.32-.96.88-2.56.88z"
          style={{
            lineHeight: 1.25,
            InkscapeFontSpecification: "'JetBrains Mono, '",
            whiteSpace: "pre",
          }}
          fontSize={40}
          fontFamily="JetBrains Mono"
          fill="#ededed"
        />
      }
      <text
        transform="translate(258.114 1.672)"
        fontWeight={400}
        fontSize={40}
        fontFamily="JetBrains Mono"
        fill="#ededed"
      >
        <tspan x={100.311} y={534.173}>{props.expiry}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{props.cvv}</tspan>
      </text>
      <text
        transform="translate(21.986 -122.7)"
        fontWeight={400}
        fontSize={69.333}
        fontFamily="JetBrains Mono"
        fill="#ededed"
      >
        <tspan x={100.311} y={560.506}>
          <tspan fill="#28262d">{FormatCardNumber(props.number)}</tspan>
        </tspan>
      </text>
      <text
        transform="translate(19.07 -125.842)"
        fontWeight={400}
        fontSize={69.333}
        fontFamily="JetBrains Mono"
        fill="#ededed"
      >
        <tspan x={100.311} y={560.506}>
          {FormatCardNumber(props.number)}
        </tspan>
      </text>
      <CardLogo {...props} />
    </svg>
  </div>
);


export default CreditCard;
